// extracted by mini-css-extract-plugin
export default {"form-input":"Autocomplete_form-input__ZA-8J"};